module.exports = __webpack_public_path__ + "static/media/landing-logo.7fdf7dbb.svg";